import { render, staticRenderFns } from "./ModalCloseSo.vue?vue&type=template&id=28a52a74&"
import script from "./ModalCloseSo.vue?vue&type=script&lang=ts&"
export * from "./ModalCloseSo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a52a74')) {
      api.createRecord('28a52a74', component.options)
    } else {
      api.reload('28a52a74', component.options)
    }
    module.hot.accept("./ModalCloseSo.vue?vue&type=template&id=28a52a74&", function () {
      api.rerender('28a52a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesOrder/ModalCloseSo.vue"
export default component.exports